<template>
  <tr>
      <!-- first name -->
      <td>{{ user.first_name }} {{ user.last_name }}</td>
      <td >
              <span id="role" v-if="user.role_id == '1'" class="font-weight-bold" style="color: #66b34d">
                <span class="bullet">• </span>Admin</span>
              <span id="role" v-if="user.role_id == '2'" class="font-weight-bold" style="color: #e95a42">
                <span class="bullet">• </span>CRM</span>
              <span id="role" v-if="user.role_id == '3'" class="font-weight-bold" style="color: #f19a16">
                <span class="bullet">• </span>Editor</span>
              <span id="role" v-if="user.role_id == '4'" class="font-weight-bold" style="color: #a682b2">
                <span class="bullet">• </span>Support</span>
              <span id="role" v-if="user.role_id == '5'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>Data Entry</span>
              <span id="role" v-if="user.role_id == '6'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>Digital Marketing</span>
              <span id="role" v-if="user.role_id == '10'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>CSM</span>
              <span id="role" v-if="user.role_id == '11'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>ADH</span>  
            </td>
      <!-- organization name -->
      <td>{{ user.organization_name }}</td>
  
      <!-- email -->
      <td>{{ user.user_name_cus }}</td>
      
      <td>
          <div v-html="sanitizeDescription(user.description)"></div>
      </td>
  
      <td>{{ user.created_at | formatDate }}</td>
  
      <!-- <th>Activity Type</th> -->
      <td>
        <span v-if="user.type===0">Pickup Cart</span>
        <span v-if="user.type===1">Incoming Cart</span>
        <span v-if="user.type===2">Outgoing Cart</span>
        <span v-if="user.type===3">Pickup Manifest</span>
        <span v-if="user.type===4">Receiving Manifest</span>
        <span v-if="user.type===5">Shipping Manifest</span>
        <span v-if="user.type===6">Invoice</span>
        <span v-if="user.type===7">Order</span>
        <span v-if="user.type===8">Invoice Statement</span>
        <span v-if="user.type===9">Customer</span>
        <span v-if="user.type===10">Login</span>
        <span v-if="user.type===11">User Note</span>
        <span v-if="user.type===12">Missing Items</span>
        <span v-if="user.type===13">CPI</span>
        <span v-if="user.type===14">Support Ticket</span>
        <span v-if="user.type===15">Rewash Cart</span>
        <span v-if="user.type===16">PPOH</span>
        <span v-if="user.type===17">Carts Picked up</span>
        <span v-if="user.type===18">User</span>
        <span v-if="user.type===19">Customer Scheduler</span>
        <span v-if="user.type===20">Stained Cart</span>
        <span v-if="user.type===21">Group Invoice</span>
        <span v-if="user.type===22">Logout</span>
        <span v-if="user.type===23">LoginFromAdmin</span>
        <span v-if="user.type===24">RFID Customer Mismatch Item</span>
        <span v-if="user.type===25">Data Sync</span>
        
      </td>
  
      <!-- <th>Action</th> -->
      <td>
        <span v-if="user.action===0">Created</span>
        <span v-if="user.action===1">Updated</span>
        <span v-if="user.action===2">Deleted</span>
        <span v-if="user.action===3">Delivered</span>
        <span v-if="user.action===4">Load</span>
        <span v-if="user.action===5">Signature</span>
        <span v-if="user.action===6">Email</span>
        <span v-if="user.action===7">Price Updated</span>
        <span v-if="user.action===8">Price Changed</span>
        <span v-if="user.action===9">Changing Soon</span>
        <span v-if="user.action===10">New Message</span>
        <span v-if="user.action===11">Price Changed Reason</span>
        <span v-if="user.action===12">Email Error</span>
        <span v-if="user.action===13">Ignored Alert</span>
        <span v-if="user.action===14">Soft Deleted</span>
        <span v-if="user.action===15">Restored</span>
        <span v-if="user.action===16">Ignored Weight Variation Alert</span>
        <span v-if="user.action===17">Ignored Max Net Weight Alert</span>
        <span v-if="user.action===18">Email Bounce</span>
        <span v-if="user.action===19">Email Spam</span>
        <span v-if="user.action===20">Login</span>
        <span v-if="user.action===21">Logout</span>
        <span v-if="user.action===22">Receiving Manifest to Order</span>
        <span v-if="user.action===23">Customer Missing</span>
        <span v-if="user.action===24">Item Missing</span>
        <span v-if="user.action===25">Customer Item Missing</span>
        <span v-if="user.action===26">Customer Department Missing</span>
        <span v-if="user.action===27">Customer Department Item Missing</span>
      </td> 
      <!-- role -->
      <!-- <td>
        <span id="role" v-if="user.role_id === 1" class="font-weight-bold" style="color: #66b34d">
          <span class="bullet">• </span>Admin</span>
        <span id="role" v-if="user.role_id === 0" class="font-weight-bold" style="color: #66b34d">
          <span class="bullet">• </span>Super Admin</span>
        <span id="role" v-if="user.role_id === 2" class="font-weight-bold" style="color: #e95a42">
          <span class="bullet">• </span>CRM</span>
        <span id="role" v-if="user.role_id === 3" class="font-weight-bold" style="color: #f19a16">
          <span class="bullet">• </span>Editor</span>
        <span id="role" v-if="user.role_id === 4" class="font-weight-bold" style="color: #a682b2">
          <span class="bullet">• </span>Support</span>
      </td> -->
  
      <!-- email notification status -->
     
    </tr>
</template>

<script>
  import moment from "moment";
  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });

  export default {
    props: ["user"],
    data() {
      return {
        
        log: {
          id: '1',
          description: 'p k Ignored Alert for unknown Cart Number (741) while creating Outgoing Cart for Brennan Mayo<span class="m-badge m-badge--brand m-badge--wide" data-toggle="m-tooltip" title="by p k" data-placement="top">Ignored Alert</span>'
        }
      };
    },
      methods: {
      sanitizeDescription(description) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = description;
        const strippedText = tempElement.textContent;
        return strippedText;
      }
    }
  };
</script>